export enum BackgroundCheckSearchEnum {
  NA = 'N/A',
  Incident = 'Incident',
  Clear = 'Clear',
}